import { useResponseContext } from './useResponseContext'

export const useStatusResult = () => {
  const { responseContext, clearContext } = useResponseContext()
  const statusResult = responseContext?.status_result

  const clear = () => clearContext()

  return { statusResult, clear }
}
